import { AvailableOrderFulfillmentFieldsFragmentDoc } from '@domain/fulfillment-settings/blocs/available-order-fulfillment-fields-fragment.generated';
import {
  AvailableOrderFulfillmentsQuery,
  AvailableOrderFulfillmentsQueryVariables,
} from '@/types';
import { gql } from '@apollo/client';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';

export const AVAILABLE_ORDER_FULFILLMENT_QUERY = gql`
  query AvailableOrderFulfillments(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    getAvailableOrderFulfillments(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      ...AvailableOrderFulfillmentFields
    }
  }

  ${AvailableOrderFulfillmentFieldsFragmentDoc}
`;

export const useAvailableOrderFulfillments = ({
  restaurantUUID,
  supplierUUID,
}: {
  restaurantUUID: string;
  supplierUUID: string;
}) => {
  const { data, loading, refetch, hasResponse } = useWrappedQuery<
    AvailableOrderFulfillmentsQuery,
    AvailableOrderFulfillmentsQueryVariables
  >(AVAILABLE_ORDER_FULFILLMENT_QUERY, {
    skip: !restaurantUUID || !supplierUUID,
    variables: {
      restaurantUUID,
      supplierUUID,
    },
  });

  return {
    data,
    hasResponse,
    loading,
    refetch,
  };
};
